import type { ReactElement } from "react";
import { Navigate } from "react-router-dom";

import { AuthPageLoading } from "@/components/layout/AuthPageShell";
import { AuthLoadError } from "@/components/shared/AuthLoadError";
import { useAuth } from "@/hooks/useAuth";
import { resolvePostAuthRoute } from "@/lib/authRouting";

export function RootRedirect(): ReactElement {
  const { user, isLoading, isError, refetch } = useAuth();

  if (isLoading) return <AuthPageLoading />;

  if (isError) return <AuthLoadError onRetry={refetch} />;

  return <Navigate to={resolvePostAuthRoute(user)} replace />;
}
